export default __webpack_public_path__ + "static/media/staff-min.44e82f14.PNG";